import React, {useEffect, useRef, useState, useMemo, useCallback} from "react";
import {useSearchParams} from "react-router-dom";
import "./GridWithBottomArea.css";
import axios from "axios";
import CentralArea from "./CentralArea";
import {useTotemContext} from "./TotemContext";
import {useMenuContext} from "./MenuContext";
import {getVideoFromIndexedDB, saveVideoToIndexedDB} from "./db";
// import { Elements, useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
// import "@stripe/stripe-js";
// import { loadStripe } from "@stripe/stripe-js";
import {createExternalOrder, subscribeNewsletter} from "../backend/api";
import {motion} from 'framer-motion';
import {ReactQRCode} from "@lglab/react-qr-code";
import {ClipLoader} from "react-spinners";

import Component1 from "./colorEditor/Component1";
import Component2 from "./colorEditor/Component2";
import Component3 from "./colorEditor/Component3";
import Component4 from "./colorEditor/Component4";
import Component5 from "./colorEditor/Component5";
import Component6 from "./colorEditor/Component6";
import Component7 from "./colorEditor/Component7";
import Component8 from "./colorEditor/Component8";
import Component9 from "./colorEditor/Component9";
import Component10 from "./colorEditor/Component10";
import Component11 from "./colorEditor/Component11";
import Component12 from "./colorEditor/Component12";
import Component13 from "./colorEditor/Component13";
import Component14 from "./colorEditor/Component14";
import Component15 from "./colorEditor/Component15";
import Component16 from "./colorEditor/Component16";
import Component17 from "./colorEditor/Component17";
import Component18 from "./colorEditor/Component18";
import Component19 from "./colorEditor/Component19";
import Component20 from "./colorEditor/Component20";
import Component21 from "./colorEditor/Component21";
import Component22 from "./colorEditor/Component22";
import Component23 from "./colorEditor/Component23";
import Component24 from "./colorEditor/Component24";
import Component25 from "./colorEditor/Component25";
import Component26 from "./colorEditor/Component26";
import Component27 from "./colorEditor/Component27";
import Component28 from "./colorEditor/Component28";
import Marquee from "./Marquee";
import DropdownSizes from "./dropdownSizes/DropdownSizes";
import {VideoPlayer} from "./VideoPlayer";
import RegisterQRCode from "./RegisterQRCode";

// 🔹 Analytics
import {useTotemAnalytics} from "../analytics/useTotemAnalytics";
import {DEFAULT_STORE_ID} from "../analytics/config";
import {useIdleTimers} from "./useIdleTimers";

const NONE_SVG = `
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120'>
    <rect width='120' height='120' fill='transparent'/>
    <g transform='translate(60,60) rotate(45)'>
      <rect x='-45' y='-6' width='90' height='12' fill='#111'/>
      <rect x='-6' y='-45' width='12' height='90' fill='#111'/>
    </g>
  </svg>
`;
const NONE_DATA_URI = "data:image/svg+xml;utf8," + encodeURIComponent(NONE_SVG);

const NONE_ITEM = {
    id: "none",
    label: "X",
    name: "Nessuno",
    image: NONE_DATA_URI,
    miniature: NONE_DATA_URI,
    url: NONE_DATA_URI,
};

const IS_LOCAL =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';

// util per cart_id
const uuid = () => (crypto.randomUUID?.() || Math.random().toString(36).slice(2));

//const stripePromise = loadStripe("pk_live_51O2sHvKXwKiRxc2L6RWG9gKqte3YVIjg6ZZxlhl9GUFGGee3EdkmB5MPHhbWBjUUhaCjRKMUddIXKbN20ySP4BOl00SK8Id72e");

function GridWithBottomArea() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [selectedColorLabel, setSelectedColorLabel] = useState("");
    const [loadedButtons, setLoadedButtons] = useState([]); // Pulsanti dinamici
    const [activeContentGrid, setActiveContentGrid] = useState(null); // Contenuto attivo
    const [isIdle, setIsIdle] = useState(false);
    const [carouselIndex, setCarouselIndex] = useState(0);
    const [carouselContent, setContent] = useState([]);
    const [savedContent, setSavedContent] = useState({}); // Salva contenuto precedente
    const [showQRCode, setShowQRCode] = useState(false); // Stato del QR code
    const [loadingqr, setLoadingQR] = useState(true);
    const [paymentURL, setPaymentURL] = useState("");
    const [activeFolder, setActiveFolder] = useState(null); // Per
    const [lastVisitedUrls, setLastVisitedUrls] = useState({});
    const [showInfo, setShowInfo] = useState(false);
    const [videoSlug, setVideoSlug] = useState(null);
    const [currentStep, setCurrentStep] = useState(1);
    const [view, setView] = useState("categories"); // Default: mostra l'iframe
    const [slug, setSlug] = useState(null);
    const [history, setHistory] = useState([]);
    const [product, setProduct] = useState(null);
    const [loadingProduct, setLoadingProduct] = useState(true);
    const [error, setError] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [colorGridItems, setColorGridItems] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState({});
    const [selectedParts, setSelectedParts] = useState({});
    const firstButtonRef = useRef(null);
    const loadedSlugs = useRef(new Set());
    const hasInitialized = useRef(false);
    const [typeMessage, setTypeMessage] = useState("logo");

    const isProd = process.env.REACT_APP_PROD === 'true'; 

    // 2. Recuperiamo gli URL e il TOKEN
    const apiProdUrl = process.env.REACT_APP_API_PROD_URL;
    const apiStageUrl = process.env.REACT_APP_API_STAGE_URL_V2;
    const apiToken = process.env.REACT_APP_API_TOKEN;

    // 3. Definiamo la BASE_URL
    const BASE_URL = isProd ? apiProdUrl : apiStageUrl;

    const [localVideoUrls, setLocalVideoUrls] = useState({});
    const [localVideoUrlIdle, setLocalVideoUrlIdle] = useState(null);

    const resetTimerRef = useRef(null);
    const idleTimerRef = useRef(null);


    const [showBfMarquee, setShowBfMarquee] = useState(false);
    useEffect(() => {
    const now = new Date();
    const year = now.getFullYear();
    // Mese 10 = novembre (0-based)
    const start = new Date(year, 10, 7, 0, 0, 0);
    const end = new Date(year, 10, 30, 23, 59, 59);

    setShowBfMarquee(now >= start && now <= end);
    }, []);

    const phrase = 'Test-1 Test-2 Test-3 Test-4 Test-5 Test-6 Test-7 Test-8 Test-9 Test-10 Test-11';

    const {totemConfig, setTotemConfig} = useTotemContext();
    const [cartItems, setCartItems] = useState([]);


    // 🔹 Parametri URL + IDs per analytics
    const getUrlParams = () => {
        const params = new URLSearchParams(window.location.search);
        return {
            config: params.get("config"),
            totem_id: params.get("totem_id"),
            store_id: params.get("store_id"),
            view: params.get("view"), // Es. categories, product, checkout
            slug: params.get("slug"), // Usato per categorie/prodotti specifici
        };
    };
    const params = getUrlParams();
    const totemId = params.totem_id || "TOTEM-LOCAL";
    const storeId = params.store_id || DEFAULT_STORE_ID;

    // 🔹 Hook analytics
    const analytics = useTotemAnalytics({totem_id: totemId, store_id: storeId});

    // 🔹 Stato tecnico per funnel carrello
    const cartIdRef = useRef(uuid());
    const cartCreatedAtRef = useRef(null); // Date.now() quando creato

    //video in locale
    const loadLocalVideo = async (videoPath) => {
        if (!videoPath) return;

        // URL assoluto
        const src = videoPath.startsWith("http")
            ? videoPath
            : `https://api.psicopatici.com/public/${videoPath}`;

        // Se sono in locale, NON faccio fetch (evito CORS) → uso direttamente l’URL
        if (IS_LOCAL) {
            setLocalVideoUrls(prev => ({...prev, [videoPath]: src}));
            return;
        }

        // Se vuoi essere ancora più sicuro, evita il fetch solo per domini che non espongono CORS:
        // if (new URL(src).hostname === 'totem.psicopatici.com') { ... }

        // --- caching reale solo in produzione ---
        let blob = await getVideoFromIndexedDB(src);
        if (!blob) {
            const response = await fetch(src); // qui serve CORS
            if (!response.ok) throw new Error(`Failed to fetch ${src}`);
            blob = await response.blob();
            await saveVideoToIndexedDB(src, blob);
        }
        const objectUrl = URL.createObjectURL(blob);
        setLocalVideoUrls(prev => ({...prev, [videoPath]: objectUrl}));
    };

    //video singolo locale
    useEffect(() => {
        // Carica tutti i video singoli (non array) presenti nei primi due bottoni
        loadedButtons.slice(0, 2).forEach((button, index) => {
            if (button.type === "video" && !Array.isArray(button.content)) {
                const src = index === 1 && videoSlug ? videoSlug : button.content;
                loadLocalVideo(src);
            }
        });
    }, [loadedButtons, videoSlug]);

    //video idle
    useEffect(() => {
        const idleButton = loadedButtons[2];
        const fallbackVideo = "https://totem.psicopatici.com/Video_totem_Ilenia_ufficiale_4.mp4";

        const src = (idleButton && idleButton.type === "video" && idleButton.content)
            ? idleButton.content
            : fallbackVideo;

        if (IS_LOCAL) {
            // niente fetch → metto direttamente l’url
            setLocalVideoUrls(prev => ({...prev, [src]: src}));
            return;
        }

        loadLocalVideo(src);
    }, [loadedButtons]);

        const fetchProduct = async (productSlug) => {
        const api = axios.create({
        baseURL: BASE_URL,
        headers: {
            'X-User-Token': apiToken
        },
        });
        try {
            const response = await api.get(`/products/slug/${productSlug}`);

            setProduct(null);

            const product = {
            ...response.data.data,
            slug: productSlug,
            };

            setProduct(product);
            loadedSlugs.current.add(productSlug);
        } catch (err) {
            console.error("Errore nel caricamento del prodotto:", err);
            setError("Errore nel caricamento del prodotto.");
        } finally {
            setLoadingProduct(false);
        }
        };

const initializeSelection = () => {
  if (hasInitialized.current || product === null) return;
  hasInitialized.current = true;

  const defaultOptions = {};
  product.options?.forEach((opt) => {
    const def = opt.values?.find((v) => v.is_default);
    if (def) defaultOptions[opt.id] = def.id;
  });

  setSelectedOptions(defaultOptions);
};


    useEffect(() => {

        initializeSelection()

        if (firstButtonRef.current) {
            firstButtonRef.current.click();
        }

    }, [product]);

    useEffect(() => {
        setView(searchParams.get("view") || "categories");
    }, [searchParams]);

    const navigateToView = (newView, newSlug = null, history = true) => {

        if (history)
            setHistory((prev) => [
                ...prev,
                {
                    view: view,
                    slug: slug,
                },
            ]);

        setView(newView);
        setSlug(newSlug);
        setSearchParams((prev) => {
            prev.set("view", newView);
            if (newSlug) {
                prev.set("slug", newSlug);
            } else {
                prev.delete("slug");
            }
            return prev;
        });

        if (newView === "product") {
            // 🔹 Tracking: product_click quando si apre una scheda prodotto
            if (newSlug) analytics.trackProductClick(String(newSlug));
            setLoadingProduct(true);
            hasInitialized.current = false;
            fetchProduct(newSlug);
        }
        // 🔹 Tracking: category_view quando si entra in una categoria/pagina catalogo
        if (newView === "categories" && newSlug) {
            analytics.trackCategoryView(String(newSlug));
        }
    };

const wrapProduct = () => {
  const firstOpt = product.options?.[0];
  const firstSelectedId = firstOpt ? selectedOptions[firstOpt.id] : null;
  const firstValue =
    firstOpt?.values?.find(v => v.id === firstSelectedId) ||
    firstOpt?.values?.find(v => v.is_default);

  return {
    id: product.id,
    qty: 1,
    name: product.name,
    price: product.price,
    sale_price: product.sale_price,
    abbigliamento: product.categories && product.categories.includes("Abbigliamento"),
    options: {
      // 👇 nuovo: base strutturata (niente più parsing stringhe)
      base: {
        option_id: firstOpt?.id ?? null,
        name: firstOpt?.name || "Base",
        value: firstValue?.label || firstValue?.name || "",
      },

      image: firstValue?.image || firstValue?.miniature || firstValue?.image_right || null,
      selectedSize: product.selectedSize,

      options: {
        optionInfo: product.options.reduce((acc, opt) => {
          acc[opt.id] = opt.name;
          return acc;
        }, {}),
        optionCartValue: product.options.reduce((acc, opt) => {
          const selected = selectedOptions[opt.id];
          if (selected) {
            const selectedValue = opt.values.find(v => v.id === selected);
            if (selectedValue) {
              const optionObj = {
                affect_price: selectedValue.affect_price ?? 0,
                affect_type: 0,
                option_type: "checkbox",
                option_value: selectedValue.label,
                image: selectedValue.image,
              };
              if (!acc[opt.id]) acc[opt.id] = [];
              acc[opt.id].push(optionObj);
            }
          }
          return acc;
        }, {}),
      },
    },
  };
};



    const handleCartButton = () => {
        setTimeout(() => {
            if (view === "product") {
                if (product.attributes.find(attr => attr.set_name === "Taglia" || attr.set_name === "Taglie") && !product.selectedSize) {
                    return;
                }

                // 🔹 Se il carrello era vuoto → cart_created
                if (cartItems.length === 0) {
                    cartIdRef.current = uuid();
                    cartCreatedAtRef.current = Date.now();
                    analytics.trackCart("cart_created", {cart_id: cartIdRef.current});
                }

                setCartItems([...cartItems, wrapProduct()])
                handleBack();
            } else if (cartItems.length !== 0) {
                if (view !== "checkout") {
                    navigateToView("checkout");
                } else {
                    handleNextStep();
                }
            }
            console.log("current step: " + currentStep)
        }, 150);
    };

    const handleHome = () => {
        setTimeout(() => {
            setSlug(null);
            setActiveFolder(null);
            setCurrentStep(1);
            navigateToView("categories", null)
        }, 150);
    };

    // Gestione pulsante "Indietro"
    const handleBack = () => {
        if (view === "checkout") {
            if (currentStep === 1) {
                const lastView = history[history.length - 1]; // Ottieni l'ultima vista dalla cronologia
                navigateToView("categories", lastView.slug, false);
            }
            //handlePrevStep();
            if (currentStep === 3) {
                setCurrentStep(1);

            }
        } else if (history.length > 0) {
            const lastView = history[history.length - 1]; // Ottieni l'ultima vista dalla cronologia
            setHistory((prev) => prev.slice(0, -1)); // Rimuovi l'ultima vista dalla cronologia
            setView(lastView.view);
            setSlug(lastView.slug);
            setSearchParams((prev) => {
                prev.set("view", lastView.view);
                prev.set("slug", lastView.slug);
                return prev;
            });
        } else if (view === "categories") {
            setActiveFolder(null);
        } else {
            console.log("Nessuna vista precedente disponibile");
        }
    };

    useIdleTimers({
        cartItems,
        cartCreatedAtRef,
        cartIdRef,
        analytics,
        navigateToView,
        setIsIdle,
        setHistory,
        setCurrentStep,
        setCartItems
    });


    // Aggiorna il contenuto in base ai parametri URL
    useEffect(() => {
        const paramsNow = getUrlParams();
        if (paramsNow.view) {
            setView(paramsNow.view);
        }
        if (paramsNow.slug) {
            setSlug(paramsNow.slug);
        }
        //updateVideoSlug(params);
        if (paramsNow.view === "categories") {
            localStorage.setItem('currentImageIndex', 0)
            if (paramsNow.slug === "scarpe-e-borse" || paramsNow.slug === "scarpe-uomo" || paramsNow.slug === "scarpe-donna") {
                setTypeMessage("logo");
            } else if (paramsNow.slug === "borse-donna") {
                setTypeMessage("logo");
            } else {
                setTypeMessage("abbigliamento");
            }
        } else if (paramsNow.view == "checkout") {
            // Se almeno un elemento del carrello ha abbigliamento = true,
            // impostiamo il messaggio su "checkout", altrimenti su "logo"
            if (cartItems.some(item => item.abbigliamento)) {
                setTypeMessage("checkout");
            } else {
                setTypeMessage("logo");
            }
        }

        if ((paramsNow.view == "categories" && !paramsNow.slug) || paramsNow.slug == "null") {
            setTypeMessage("logo");
        }
    }, [searchParams]);

    //qui va ad aggiornare il video che sta sulla destra a seconda della categoria
    //tramite i params devo andare a fare la chiamata API specifica.
    const updateVideoSlug = async (params) => {
        try {
            const response = await fetch("https://your-api-endpoint.com/api/videoSlug");
            if (response.ok) {
                const data = await response.json();
                setVideoSlug(data);
            } else {
                console.error('Errore nella richiesta:', response.status);
            }
        } catch (error) {
            console.error('Errore nel fetch:', error);
        }
    };

    const handleNextStep = () => {
        setCurrentStep((prev) => Math.min(prev + 1, 3));
    };

    const handlePrevStep = () => {
        setCurrentStep((prev) => Math.max(prev - 1, 1));
    };


    useEffect(() => {
        const totemsParams = searchParams.get("totem_id");
        if (totemsParams === 0) {
            return;
        }

        // Simulazione API per ottenere pulsanti dinamici
        fetch("https://api.psicopatici.com/api/totems/" + totemsParams)
            .then((response) => response.json())
            .then((data) => {
                const defaultButtons = data?.slides || [];
                console.log('defaultButtons', defaultButtons);

                // Raggruppa i pulsanti per element_id
                const groupedButtons = defaultButtons.reduce((acc, button) => {
                    if (!acc[button.element_id]) {
                        // Per l'elemento con element_id === 3, assegna direttamente il content come stringa
                        if (button.element_id === 3) {
                            acc[button.element_id] = {...button, content: button.content};
                        } else {
                            acc[button.element_id] = {...button, content: [{type: button.type, url: button.content}]};
                        }
                    } else {
                        // Per gli altri elementi, aggiungi al contenuto come array
                        acc[button.element_id].content.push({type: button.type, url: button.content});
                    }
                    return acc;
                }, {});

                // Completa gli spazi vuoti fino a 12
                const completeGrid = Array.from({length: 12}, (_, index) => {
                    const elementId = index + 1;
                    return groupedButtons[elementId] || {id: `placeholder-${elementId}`, type: "placeholder"};
                });

                setLoadedButtons(completeGrid);
                console.log('loadedButtons', completeGrid);

                // Imposta il pulsante 6 come predefinito (se esiste)
                const defaultButton = completeGrid.find((b) => b.element_id === 6);
                if (defaultButton) {
                    console.log('activeContent', defaultButton);
                    setActiveContentGrid(defaultButton);
                }
            })
            .catch((err) => console.error(err));
    }, [activeContentGrid, cartItems]);


    useEffect(() => {
        // Listener postMessage dallo store
        const handleMessage = (event) => {
            if (event.origin === "https://store.psicopatici.com") {
                const {lastVisited} = event.data;
                if (lastVisited && activeContentGrid?.element_id) {
                    setLastVisitedUrls((prev) => ({
                        ...prev,
                        [activeContentGrid.element_id]: lastVisited,
                    }));
                }
            }
        };
        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, [activeContentGrid]);

    const buttonClickHandler = (button) => {
        if (button.type === "placeholder") return;
        if (button.id === 8) {
            setShowQRCode(true);
            return;
        }
        setActiveContentGrid(button);
    };

    const closeQRCode = () => {
        setShowQRCode(false);
    };


    if (isIdle) {
        return (
            <div className="carousel-fullscreen">
                <video
                    src={localVideoUrls["https://totem.psicopatici.com/Video_totem_Ilenia_ufficiale_4.mp4"]
                        || "https://totem.psicopatici.com/Video_totem_Ilenia_ufficiale_4.mp4"}
                    autoPlay
                    loop
                    style={{width: "100%", height: "100%", objectFit: "cover"}}
                />
            </div>
        );
    }

    // Componenti dinamici
    const isRequired = (v) => v === true || v === 1 || v === '1' || v === 'true';

    const ColorEditor = () => {
        const [size, setSize] = useState(null);

       
    useEffect(() => {
    const optId = selectedCategory;
    if (!optId) return;

    const valueId = selectedOptions[optId];
    if (!valueId) {
        setSelectedColorLabel("");
        return;
    }

    const opt = product?.options?.find(o => o.id === optId);
    const val = opt?.values?.find(v => v.id === valueId);
    setSelectedColorLabel(val?.label || "");
    }, [selectedOptions, selectedCategory, product]);


        const handleTabClick = async (optionId) => {
  setSelectedCategory(optionId);

  const CDN = "https://cdn.psicopaticiservice.com/";

  // Funzione che controlla se -totem esiste, altrimenti fallback
  const checkTotemImage = (rawMiniature) => {
    return new Promise((resolve) => {
      if (!rawMiniature) return resolve("");
      const totemUrl = CDN + rawMiniature.replace(/\.(jpg|png|webp|jpeg)$/, "-totem.$1");
      const normalUrl = CDN + rawMiniature;

      const img = new Image();
      img.src = totemUrl;
      img.onload = () => resolve(totemUrl);
      img.onerror = () => resolve(normalUrl);
    });
  };

  const normalizeItem = async (it) => {
    const rawMiniature = it?.miniature || "";
    const bg = await checkTotemImage(rawMiniature);
    return { ...it, bg };
  };

  let items = product.options.find(opt => opt.id === optionId)?.values || [];

  // prepend X se non required
  const optionObj = product.options.find(opt => opt.id === optionId);
  if (!isRequired(optionObj?.required)) {
    const xTile = { ...NONE_ITEM, image: NONE_ITEM.miniature };
    items = [xTile, ...items];
  }

  items = await Promise.all(items.map(normalizeItem));
  setColorGridItems(items);
};


        const handleColorSelection = (optionId, valueId) => {
  const optionObj = product.options.find(opt => opt.id === optionId);
  const requiredFlag = optionObj?.required;

  // click X => rimuovi
  if (valueId === "none") {
    setSelectedOptions(prev => {
      const next = { ...prev };
      delete next[optionId];
      return next;
    });
    setSelectedColorLabel("");
    setSelectedParts(prev => ({ ...prev, [optionId]: null }));
    return;
  }

  // riclick stesso valore => toggle off se non required
  if (selectedOptions[optionId] === valueId && !isRequired(requiredFlag)) {
    setSelectedOptions(prev => {
      const next = { ...prev };
      delete next[optionId];
      return next;
    });
    setSelectedColorLabel("");
    return;
  }

  setSelectedOptions(prev => ({ ...prev, [optionId]: valueId }));

  const val = optionObj?.values?.find(v => v.id === valueId);
  setSelectedColorLabel(val?.label || "");
  setSelectedParts(prev => ({ ...prev, [optionId]: val?.image || null }));
};



        const capitalizeFirstLetter = (str) => {
            if (!str) return "";
            return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        };

        const getGridColumns = () => {
            if (colorGridItems.length <= 4) return "repeat(4, 1fr)";
            if (colorGridItems.length <= 6) return "repeat(6, 1fr)";
            if (colorGridItems.length <= 8) return "repeat(8, 1fr)";
            return "repeat(auto-fit, minmax(50px, 1fr))";
        };

        if (loadingProduct) return <div>Caricamento...</div>;
        if (error) return <div>{error}</div>;
        if (!product) return <div>Prodotto non trovato.</div>;


        const handleChangeSize = (size) => {
            setSize(size);
            product.selectedSize = size;
        }

        const hasSizes = (product) => {
            return !product.categories.includes("Abbigliamento");
        }

        const currentIsOption = !!product.options.find(opt => opt.id === selectedCategory);
        const uiSelectedColor =
            selectedOptions[selectedCategory] ??
            (currentIsOption && colorGridItems?.[0]?.id === 'none' ? 'none' : undefined);

        return <div className="main-container">
            {hasSizes(product) &&
                <DropdownSizes product={product} handleChangeSize={handleChangeSize} current={size}/>
            }
            <div className="product-info-bar d-flex align-items-center">
                <div className={`product-name`}>{product.name}
                    <div
                        className="info-icon"
                        onClick={() => setShowInfo(!showInfo)}
                        title="Clicca per maggiori informazioni"
                    >
                        <i className="fas fa-info"></i>
                    </div>
                    <div className="ms-2">
                        <p className="mb-0">{capitalizeFirstLetter(selectedColorLabel)}</p>
                    </div>
                </div>
                {showInfo && (
                    <div style={{zIndex: "10000"}} className={`product-tooltip  ${hasSizes(product) ? "sizeable" : "asda"}`}
                         dangerouslySetInnerHTML={{__html: product.description}}>
                    </div>
                )}
            </div>
            {/* Barra superiore con 8 tab */}
            <div className="top-bar">
                {product.options
                    .slice(0, 9)
                    .map((attr, index) => {
                        const isOption = !!attr.values;
                        const isActive = isOption
                            ? selectedCategory === attr.id
                            : selectedCategory === attr.id;

                        let buttonLabel = attr.set_name || attr.name;
                        if (buttonLabel && buttonLabel.includes("-")) {
                            buttonLabel = buttonLabel.split("-")[0].trim();
                        }

                        return (
                            <button
                                key={attr.id}
                                ref={index === 0 ? firstButtonRef : null}
                                className={`option-button button-configurator ${isActive ? 'active' : ''}`}
                                onClick={() => {
                                    handleTabClick(attr.id, isOption ? "option" : "variation")
                                }}
                            >
                                {buttonLabel}
                            </button>
                        );
                    })}
            </div>

            {/* Contenitore laterale e griglia */}
            <div className="content" style={{gap: "0px"}}>
                <div className="side-bar" style={{width: "129px"}}>
                    {product.options
                        .slice(9, 18)
                        .map(attr => {
                            const isOption = !!attr.values;
                            const isActive = isOption
                                ? selectedCategory === attr.id
                                : selectedCategory === attr.set_name;

                            return (
                                <button
                                    key={attr.id}
                                    className={`option-button button-configurator ${isActive ? 'active' : ''}`}
                                    onClick={() => {
                                        handleTabClick(attr.id, isOption ? "option" : "variation")
                                    }}
                                >
                                    {attr.set_name || attr.name}
                                </button>
                            );
                        })}
                </div>

                <div className="container mb-4 w-100" style={{height: "18vh", padding: "10px"}}>
                    {colorGridItems.length === 1 &&
                        <Component1 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                    items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 2 &&
                        <Component2 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                    items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 3 &&
                        <Component3 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                    items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 4 &&
                        <Component4 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                    items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 5 &&
                        <Component5 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                    items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 6 &&
                        <Component6 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                    items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 7 &&
                        <Component7 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                    items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 8 &&
                        <Component8 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                    items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 9 &&
                        <Component9 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                    items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 10 &&
                        <Component10 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                     items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 11 &&
                        <Component11 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                     items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 12 &&
                        <Component12 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                     items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 13 &&
                        <Component13 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                     items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 14 &&
                        <Component14 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                     items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 15 &&
                        <Component15 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                     items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 16 &&
                        <Component16 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                     items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 17 &&
                        <Component17 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                     items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 18 &&
                        <Component18 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                     items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 19 &&
                        <Component19 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                     items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 20 &&
                        <Component20 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                     items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 21 &&
                        <Component21 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                     items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 22 &&
                        <Component22 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                     items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 23 &&
                        <Component23 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                     items={colorGridItems}
                                     selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 24 &&
                        <Component24 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                     items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 25 &&
                        <Component25 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                     items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 26 &&
                        <Component26 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                     items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 27 &&
                        <Component27 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                     items={colorGridItems} selectedColor={uiSelectedColor}/>}
                    {colorGridItems.length === 28 &&
                        <Component28 selectedCategory={selectedCategory} handleSelection={handleColorSelection}
                                     items={colorGridItems} selectedColor={uiSelectedColor}/>}
                </div>
            </div>
        </div>;

    };

    const PaymentCard = () => {
        const [cardData, setCardData] = useState({
            number: "",
            name: "",
            expiry: "",
            cvc: "",
            focus: "",
        });
        const [showSensitiveData, setShowSensitiveData] = useState(false); // Mostra/nascondi i dati sensibili
        const [newsletterSubscription, setNewsletterSubscriptiob] = useState(false);
        const [isChecked, setIsChecked] = useState(false); // Stato per la checkbox dei termini e le condizioni
        const [error, setError] = useState("");
        const [clientSecret, setClientSecret] = useState("");
        // const stripe = useStripe();
        // const elements = useElements();
        const [user, setUser] = useState({
            email: "",
            address: "",
            houseNumber: "",
            zipCode: "",
            city: "",
            state: "",
            name: "",
            surname: ""
        })

        const fastPay = true;

        const handleSubmit = () => {
            if (currentStep === 2) {
                const paramsNow = getUrlParams();
                const totemsParams = paramsNow.totem_id;
                createExternalOrder(totemsParams, user, cartItems, setLoadingQR, setPaymentURL);
                setCountdown(15);
                setCurrentStep(3);
            }
        };

        useEffect(() => {
            console.log(currentStep)
            if (currentStep === 2) {
                console.log("entrato submit")
                handleSubmit();
            }
        }, [currentStep]);

        const handleCheckboxChange = (event) => {
            setIsChecked(event.target.checked);
        };

        const handleInputChange = (e) => {
            const {name, value} = e.target;

            if (name === "number") {
                const formattedNumber = value
                    .replace(/\s/g, "")
                    .replace(/(\d{4})/g, "$1 ")
                    .trim();
                setCardData((prev) => ({
                    ...prev,
                    [name]: formattedNumber,
                }));
            } else {
                setCardData((prev) => ({
                    ...prev,
                    [name]: value,
                }));
            }
        };

        const handleInputFocus = (e) => {
            setCardData((prev) => ({
                ...prev,
                focus: e.target.name,
            }));
        };

        const handleNameChange = (e) => {
            const fullName = e.target.value;
            const [name, ...cognomeArr] = fullName.split(" ");
            const surname = cognomeArr.join(" ");

            setUser({...user, fullName, name, surname});
        };

        const handleFieldChange = (e) => {
            console.log("Campo modificato:", e.target.name, "Nuovo valore:", e.target.value);
            setUser({
                ...user,
                [e.target.name]: e.target.value
            });
        };

        const toggleSensitiveDataVisibility = () => {
            setShowSensitiveData((prev) => !prev);
        };

        const [countdown, setCountdown] = useState(120); //da impostare 120

        useEffect(() => {
            if (view === "checkout" && currentStep === 3) {
                if (countdown === 0) {
                    setHistory([]);
                    setCurrentStep(1);
                    setCartItems([]);
                    navigateToView("categories");
                }
            }

            const interval = setInterval(() => {
                setCountdown(prev => (prev > 0 ? prev - 1 : 0));
            }, 1000);

            // Pulisci l'intervallo quando il countdown raggiunge 0
            return () => clearInterval(interval);

        }, [countdown]);

        const formatTime = (timeInSeconds) => {
            if (timeInSeconds < 60) {
                return `${timeInSeconds}`;
            }
            const minutes = Math.floor(timeInSeconds / 60);
            const seconds = timeInSeconds % 60;
            return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
        };

        return (
            <div className="main-container">
                <div className="payment-wizard">
                    {currentStep === 1 && (
                        <div>
                            <div style={{textAlign: "center", padding: "20px", marginTop: "30%"}}>
                                <i className="fas fa-cart-plus fa-4x" style={{color: "#ccc"}}></i>
                                <h3 style={{marginTop: "10px", color: "#999"}}>Checkout</h3>
                                <p style={{color: "#999"}}>
                                    Hai quasi finito! Revisiona il carrello e procedi al pagamento.
                                </p>
                            </div>
                            {typeMessage === "checkout" &&
                                <div className={"sizes-alert"}>
                                    <p>NON PREOCCUPARTI DELLA TAGLIA! DOPO L’ACQUISTO RICEVERAI MEZZO MAIL LE
                                        ISTRUZIONI
                                        PER UTILIZZARE L'APP E COMUNICARCI LE TUE MISURE.
                                        IN CASO DI ERRORE, CI RISPEDISCI IL PRODOTTO E PENSIAMO A TUTTO NOI!
                                    </p>
                                </div>
                            }
                        </div>

                    )}
                    {currentStep === 3 && (!true ? (
                            <div></div>
                        )
                        : (
                            <div className={"qr-code-payment"}>
                                <h3 className="mobile-payment-text mb-5">Continua il pagamento su smartphone!</h3>
                                {loadingqr ? (<ClipLoader
                                            color={"#000000"}
                                            loading={loadingqr}
                                            size={150}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                        />
                                    ) :
                                    (
                                        <div>
                                            <ReactQRCode value={paymentURL}
                                                         size={256}
                                                         marginSize={0}
                                                         dataModulesSettings={{
                                                             color: "#000000",
                                                             style: "rounded",
                                                             randomSize: false
                                                         }}
                                                         finderPatternOuterSettings={{style: "rounded"}}
                                                         finderPatternInnerSettings={{style: "rounded-sm"}}
                                                         imageSettings={{
                                                             src: "../../../assets/img/qr-code-logo2.png",
                                                             width: 50,
                                                             height: 50,
                                                             excavate: true
                                                         }}/>
                                            <div className="d-flex justify-content-center align-items-center mt-4">
                                                <p className="countdowun mb-0">Questo codice scadrà tra:</p>
                                                <p
                                                    className={`counttext mb-0 d-flex align-items-center ms-1 ${countdown <= 30 ? "blinkcount" : ""}`}
                                                    style={{
                                                        marginTop: "2px",
                                                        color: countdown <= 30 ? "red" : "black"
                                                    }}
                                                >
                                                    {formatTime(countdown)}
                                                </p>
                                            </div>
                                        </div>
                                    )
                                }

                            </div>
                        ))}
                </div>
            </div>
        );
    };

    const NavigationBar = ({
                               setView, setSlug, setSearchParams, view, slug
                           }) => {
        const {menuItems} = useMenuContext();
        const [activeIconIndex, setActiveIconIndex] = useState(null);

        useEffect(() => {
            const params = new URLSearchParams(window.location.search);
            const updatedView = params.get("view") || "categories";
            const updatedSlug = params.get("slug") || null;

            if (view !== updatedView || slug !== updatedSlug) {
                setActiveIconIndex(null);
            }
        }, [window.location.search]);

        const handleIconClick = (index, newView, newSlug) => {
            const viewToSet = newSlug && newSlug.includes("https://") ? "iframe" : newView;

            // (opzionale) tracking immediato al click:
            if (viewToSet === "categories" && newSlug) {
                analytics.trackCategoryView(String(newSlug));
            }

            if (index !== activeIconIndex) {
                setActiveIconIndex(index);
            }
            navigateToView(viewToSet, newSlug);
        };

        const handleFolderClick = (folder, newView) => {
            const viewToSet = folder.url && folder.url.includes("https://") ? "iframe" : newView;

            // (opzionale) tracking immediato al click:
            if (viewToSet === "categories" && folder.url) {
                analytics.trackCategoryView(String(folder.url));
            }

            navigateToView(viewToSet, folder.url);
            setActiveFolder(folder);
            console.log(folder)
        };

        const generateRandomColor = () => {
            const letters = "0123456789ABCDEF";
            let color = "#";
            for (let i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        };

        if (view !== "categories" && view !== "iframe") {
            return null;
        }

        return (
            <div className="menu-grid">

                {/* Overlay per sfocare il contenuto sottostante */}
                {activeFolder && (
                    <div
                        className="overlay"
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            zIndex: 1,
                        }}
                    ></div>
                )}

                {/* Schermata principale */}
                {!activeFolder && (
                    <>
                        <div className="d-flex px-4 justify-content-between w-100">
                            {menuItems.map((item, index) => (
                                <div className="menu-wrapper" key={item.id}>
                                    <motion.div
                                        initial={{opacity: 0}}
                                        animate={{opacity: 1}}
                                        exit={{opacity: 0}}
                                        transition={{duration: 0.5}}
                                        className={`menu-item ${index === activeIconIndex ? "active" : ""}`}
                                        onClick={() => {
                                            item.children.length > 0 ? handleFolderClick(item, "categories") : handleIconClick(index, "categories", item.url);
                                            localStorage.setItem("updateSlug", item.url);
                                        }
                                        }
                                        style={{
                                            backgroundImage: item.icon
                                                ? `url(https://cdn.psicopaticiservice.com/${item.icon})`
                                                : "none",
                                            backgroundColor: !item.icon ? generateRandomColor() : "transparent",
                                            backgroundSize: "cover",
                                            backgroundPosition: "center",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "#fff",
                                            fontWeight: "bold",
                                            textShadow: "0 1px 2px rgba(0, 0, 0, 0.5)",
                                            height: "100px",
                                            width: "100px",
                                            cursor: "pointer",
                                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                        }}
                                    />
                                    <span className="menu-title">{item.title}</span>
                                </div>
                            ))}
                        </div>
                        <RegisterQRCode totemId={totemId}/>
                    </>
                )}

                {/* Vista della cartella */}
                {activeFolder && (
                    <div
                        className="folder-view"
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            zIndex: 2,
                            display: "flex",
                            flexDirection: "column-reverse",
                            padding: "10px",
                        }}
                    >
                        <motion.div
                            initial={{opacity: 0}}
                            animate={{opacity: 1}}
                            exit={{opacity: 0}}
                            transition={{duration: 0.5}}
                            className="d-flex flex-column-reverse w-100">
                            <h3
                                className="folder-title mt-0"
                                style={{
                                    textAlign: "center",
                                    marginBottom: "20px",
                                    fontSize: "18px",
                                    fontWeight: "bold",
                                    lineHeight: "1.4",
                                }}
                            >
                                {activeFolder.title}
                            </h3>
                            <div className="m-0 mt-4" style={{paddingLeft: "32%", paddingRight: "32%"}}>
                                <hr className="m-0"
                                    style={{border: '3px solid black', opacity: 1, borderRadius: "10px"}}/>
                            </div>
                            <div className="folder-grid">
                                {activeFolder.children.map((child, index) => (
                                    <div className="folder-wrapper" key={child.id}>
                                        <motion.div
                                            initial={{opacity: 0}}
                                            animate={{opacity: 1}}
                                            exit={{opacity: 0}}
                                            transition={{duration: 0.5}}
                                            className={`folder-item ${index === activeIconIndex ? "active" : ""}`}
                                            style={{
                                                backgroundImage: child.icon ? `url(https://cdn.psicopaticiservice.com/${child.icon})` : "none",
                                                backgroundColor: !child.icon ? generateRandomColor() : "transparent",
                                                backgroundSize: "cover",
                                                backgroundPosition: "center",
                                                height: "100px",
                                                width: "100px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                color: "#fff",
                                                fontWeight: "bold",
                                                textShadow: "0 1px 2px rgba(0, 0, 0, 0.5)",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => {
                                                if (child.children && child.children.length > 0) {
                                                    handleFolderClick(child);
                                                } else {
                                                    handleIconClick(index, "categories", child.url);
                                                    localStorage.setItem("updateSlug", child.url);
                                                }
                                            }}
                                        >
                                        </motion.div>
                                        <span style={{fontWeight: "400"}}
                                              className="folder-title">{child.title}</span>
                                    </div>

                                ))}
                            </div>
                        </motion.div>
                    </div>
                )}

            </div>
        );
    };

    const showButtonName = (view) => {
        switch (view) {
            case "checkout":
                return "PROCEDI"
            case "product":
                return "AGGIUNGI AL CARRELLO"
            default:
                return `${cartItems.length} CASSA`;
        }
    }

    return (
        <div className="grid-with-central-area">

            {showQRCode && activeContentGrid?.type === "url" && (
                <div className="qr-code-overlay" onClick={closeQRCode}>
                    <ReactQRCode value={activeContentGrid.content} size={256}/>
                    <p>Scansiona per continuare la navigazione sul tuo smartphone</p>
                </div>
            )}
            {/* RIGA SUPERIORE */}

            <div className="grid-row top-row">
                {loadedButtons.slice(0, 2).map((button, index) => {
                    // Placeholder
                    if (button.type === "placeholder") {
                        return <div key={index} className="banner hide-placeholder"/>;
                    }

                    // Caso video multipli: content è array
                    if (button.type === "video" && Array.isArray(button.content)) {
                        return <VideoPlayer key={index} button={button}/>;
                    }

                    // Caso video singolo (string) o videoSlug al secondo slot
                    if (button.type === "video") {
                        const src = index === 1 && videoSlug ? videoSlug : button.content;
                        return (
                            <div key={index} className="banner pointer-events">
                                <video
                                    src={localVideoUrls[src] || `https://api.psicopatici.com/public/${src}`}
                                    style={{
                                        cursor: "pointer",
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                    }}
                                    autoPlay
                                    muted
                                    loop
                                    controls={false}
                                />
                            </div>
                        );
                    }

                    // Caso immagine
                    if (button.type === "image") {
                        return (
                            <div key={index} className="banner pointer-events">
                                <img
                                    src={`https://api.psicopatici.com/public/${button.content}`}
                                    alt={button.name}
                                    style={{
                                        cursor: "pointer",
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                    }}
                                />
                            </div>
                        );
                    }

                    // Caso QR
                    if (button.type === "qr") {
                        return (
                            <div key={index} className="banner pointer-events">
                                <button
                                    style={{
                                        backgroundColor: "#000",
                                        backgroundSize: "cover",
                                        width: "100%",
                                        height: "100%",
                                        border: "none",
                                        cursor: "pointer",
                                        display: "inline-block",
                                    }}
                                >
                                    <ReactQRCode value={activeContentGrid.content} size={100}/>
                                    <p>Scansiona per continuare la navigazione sul tuo smartphone</p>
                                </button>
                            </div>
                        );
                    }

                    // Caso URL
                    if (button.type === "url") {
                        return (
                            <div key={index} className="banner pointer-events">
                                <button
                                    onClick={() => buttonClickHandler(button)}
                                    style={{
                                        backgroundImage: `url(https://api.psicopatici.com/public/${button.file})`,
                                        backgroundSize: "cover",
                                        width: "100%",
                                        height: "100%",
                                        border: "none",
                                        cursor: "pointer",
                                    }}
                                    className="url"
                                >
                                    <span>{button.name}</span>
                                </button>
                            </div>
                        );
                    }

                    return null;
                })}
            </div>

            {/* SEZIONE BOTTOM CON COLONNE LATERALI */}
            <div className="grid-middle-row">
                {/* AREA CENTRALE */}
                <CentralArea  selectedOptions={selectedOptions}
                             product={product}
                             cartItems={cartItems} setCartItems={setCartItems}
                             setSelectedColorLabel={setSelectedColorLabel} selectedColorLabel={selectedColorLabel}
                             view={view} slug={slug}
                             navigateToView={navigateToView} step={currentStep}></CentralArea>
                <div className="side-column-v2">
                    <div>
                        <div className="adv-marquee">
                            {showBfMarquee ? (
                            <Marquee
                                text="10% AL PRIMO ACQUISTO DOPO LA REGISTRAZIONE &nbsp; &nbsp; &nbsp;"
                            />
                            ) : (
                            <>
                                {typeMessage === "scarpe" && (
                                <Marquee
                                    text="CONCLUDI L'ACQUISTO E RICEVERAI VIA EMAIL LE INDICAZIONI PER COMUNICARCI LA TUA MISURA. &nbsp; &nbsp; &nbsp;"
                                />
                                )}

                                {typeMessage === "abbigliamento" && (
                                <Marquee
                                    text="CONCLUDI L'ACQUISTO E RICEVERAI VIA EMAIL LE INDICAZIONI PER COMUNICARCI LE TUE MISURE. &nbsp; &nbsp; &nbsp;"
                                />
                                )}

                                {typeMessage === "checkout" && (
                                <Marquee
                                    text="DOPO L’ACQUISTO RICEVERAI MEZZO MAIL LE ISTRUZIONI PER UTILIZZARE L'APP E COMUNICARCI LE TUE MISURE. "
                                />
                                )}

                                {typeMessage === "logo" && (
                                <Marquee
                                    text="PERSONALIZZA IL TUO PRODOTTO &nbsp; &nbsp; &nbsp; PRODUZIONE SU ORDINAZIONE &nbsp; &nbsp; &nbsp; LABORATORIO ARTIGIANALE 100% MADE IN ITALY &nbsp; &nbsp;&nbsp;&nbsp; 10% DI SCONTO AL PRIMO ACQUISTO DOPO LA REGISTRAZIONE &nbsp; &nbsp; &nbsp;"
                                />
                                )}
                            </>
                            )}
                        </div>
                        </div>


                    <NavigationBar view={view}/>
                    <div>
                        {view === "product" && (!loadingProduct && <ColorEditor/>)}
                        {/*<Elements stripe={stripePromise}>*/}
                        {view === "checkout" && <PaymentCard/>}
                        {/*</Elements>*/}
                        {view === "iframe" && (
                            <div className="main-container"></div>
                        )}

                        <div className="">
                            {currentStep < 2 &&
                                <>
                                    <motion.div style={{zIndex: "9999"}} className="header-bar">
                                        <div className="flex-1">
                                            {view !== "categories" && (
                                                <button style={{zIndex: "99999"}} hidden={currentStep >= 2}
                                                        className="btn btn-black me-0"
                                                        onClick={() => handleCartButton()}>
                                                    {showButtonName(view)}
                                                </button>
                                            )}
                                            {view === "categories" && (
                                                <button className="btn1 me-0" onClick={() => handleCartButton()}>
                                                    CASSA
                                                    {cartItems.length > 0 &&
                                                        <span className="badge">{cartItems.length}</span>}
                                                </button>
                                            )}
                                        </div>
                                        <div className="flex-center">
                                            <button className="btn1" onClick={() => handleHome()}>
                                                <i className="fa-solid fa-house fa-2xl p-0"></i>
                                            </button>
                                        </div>
                                        <div className="flex-1">
                                            <button className="btn btn-white ms-0 me-0" onClick={handleBack}>
                                                <i className="fas fa-chevron-left"></i> INDIETRO
                                            </button>
                                        </div>
                                    </motion.div>

                                </>

                            }
                            {currentStep >= 2 &&
                                <div className="header-bar">
                                    <motion.button
                                        initial={{opacity: 0.2}}
                                        animate={{opacity: 1}}
                                        exit={{opacity: 0}}
                                        transition={{duration: 1}}
                                        className="btn btn-white" onClick={handleBack}>
                                        <i className="fas fa-chevron-left"></i> INDIETRO
                                    </motion.button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GridWithBottomArea;
